import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'What AI platforms does Andoe track?',
  answer: 'Andoe currently tracks ChatGPT and Google (including Gemini, AI Overview, and AI Mode). You can also add Perplexity, Claude, DeepSeek, and Copilot for an additional fee.'
}, {
  question: 'How often is data updated?',
  answer: 'Your prompts are run across AI models daily, so you get fresh visibility data every day.'
}, {
  question: "What's a prompt in Andoe?",
  answer: "A prompt is a question your customers might ask an AI system — like 'What's the best CRM for startups?' You define them based on your market and customer intent."
}, {
  question: 'Do I need any technical setup?',
  answer: 'No. Just add the prompts you want to track and the competitors you want to monitor. Andoe handles everything else.'
}, {
  question: 'How is this different from SEO tools?',
  answer: 'SEO tools track search engine rankings and keywords. Andoe tracks how AI systems describe, recommend, and compare your brand in conversational responses — a fundamentally different discovery channel.'
}, {
  question: 'Can I try it before committing?',
  answer: "Book a demo and we'll run your prompts live using your company data so you can see exactly what Andoe looks like for your brand."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-[#FAF9F7] py-24 px-4 border-t border-[#E8E6E3]" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <h2 className="text-3xl md:text-[2.5rem] font-medium tracking-tight text-[#0F0F0F] text-center mb-16" data-id="element-30">
          Frequently asked questions
        </h2>

        <div className="space-y-0 border-t border-[#E8E6E3]" data-id="element-31">
          {faqs.map((faq, index) => <div key={index} className="border-b border-[#E8E6E3]" data-id="element-32">
              <button onClick={() => toggleFAQ(index)} className="w-full py-6 flex items-center justify-between text-left group focus:outline-none" aria-expanded={openIndex === index} data-id="element-33">
                <span className="text-lg font-medium text-[#0F0F0F] group-hover:text-[#5C5C5C] transition-colors pr-8" data-id="element-34">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#9B9B9B] transition-transform duration-200 flex-shrink-0 ${openIndex === index ? 'rotate-180 text-[#0F0F0F]' : ''}`} data-id="element-35" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100 mb-6' : 'max-h-0 opacity-0'}`} data-id="element-36">
                <p className="text-[15px] text-[#5C5C5C] leading-relaxed pr-8" data-id="element-37">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}